// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"YM-z","inlineTitle":"ZM-z","sponsoredAdsWrapper":"_M-z","marketplaceRecosWrapper":"aN-z"};